import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import * as Tgcc from '../tgccGlobal';
import * as TgccRequest from '../tgccRequest';
import Radium, { StyleRoot } from 'radium';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {BulletLine} from '../Components/BulletLine';
import {DesignLicense} from '../DesignSelector/DesignLicense';
import {DesignLicenseHeader} from '../DesignSelector/DesignLicenseHeader';
import {CampusDesignCard} from '../DesignSelector/CampusDesignCard';
import {CampusFooter} from '../Components/CampusFooter';
import {CloseX} from '../Components/CloseX';
import {ScreenDoor} from '../Components/ScreenDoor';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFeedback} from './CampusFeedback';

const licenseContainerStyle : CSSProperties = {
    position: 'relative',
    width: '90%',
    maxHeight: '90%',
    minHeight: '140px',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 30px',
    textTransform: 'uppercase',
    marginBottom: '100px',
    flexShrink: 1,
    '@media (max-width:800px) and (max-height:1280px)': {
        width:'95%'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        width:'94%'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        width:'94%'
    },
    '@media (max-width:320px)': {
        width:'275px',
    }
};


const licenseListStyle : CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: '5px',
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: '15px',
    marginLeft: '35px',
    lineHeight: '15px',
    maxHeight: '80%'
};

const selectorStyle : CSSProperties = {
    position: 'position',
    display: 'flex',
    zIndex: 2,
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    top:'10%',
};

const catalogStyle : CSSProperties = {
    display: 'flex',
    flexWrap: 'wrap',
    width: '1053px',
    flexGrow: 2,
    overflowY: 'auto',
    marginBottom:'100px',
};

const otherSchoolLink: React.CSSProperties = {
    textDecoration:'underline',
    cursor:'pointer',
    fontFamily:'Lulo',
    textAlign:'center',
    color:'#626161',
}

const addToProofBtn: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#D7D7D7',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#626262',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Lulo'
}


type StateType = {
    filter: string,
    licenseId: number,
    design: Tgcc.Design,
    zoomDesign: Tgcc.Design,
    Licenses: Tgcc.License[],
    Designs: Tgcc.Design[],
    isWaiting: boolean
}

class _Schools extends React.Component<Tgcc.BaseProps, any>{

openDesign = () => { browserHistory.push(Tgcc.Routes.DesignLicensedListView( this.state.licenseId ))};
openOtherSchools = () => {browserHistory.replace(Tgcc.Routes.OtherSchools)};
 componentWillMount() {
        document.body.style.overflow = 'hidden';
        this.clearState();

        if(!this.props.state.ActiveProof){
            this.props.dispatch({type: Tgcc.StateAction.SetActiveProof, payload: new Tgcc.Proof()});
        }
        TgccRequest.getDesignLicenses((licenses : Tgcc.License[]) => this.DesignLicensesLoaded(licenses));
    }
 componentDidMount(){
        var licenseId = this.props.location.query.licenseId;
        console.log("active design license id", licenseId);
        this.handleFilterByLicense(licenseId);
        var tag = document.getElementById('schoolPage');
        tag.scrollIntoView(false);
 }
 scrollPageToView = (id: string) => {
    var el = document.getElementById(id);
    var scroller = document.getElementById("Scroller");
    scroller.scrollTop = el.offsetTop - 75;
}


    state: StateType = {
        filter: null,
        design: null,
        licenseId: null,
        zoomDesign: null,
        Licenses: null,
        Designs: null,
        isWaiting: true
    }

    clearState = () => {
        this.setState({
            filter: null,
            category: null,
            design: null,
            zoomDesign: null,
            Licenses: null,
            Designs: null,
            isWaiting:true});
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByLicense, payload: null})
    }

    DesignLicensesLoaded(licenses : Tgcc.License[]) {
        this.setState({Licenses: licenses});
    }

    getSelectedLicense() : Tgcc.License {
        if(this.state.Licenses && this.props.state.FilterDesignsByLicense){
            for (var i in this.state.Licenses){
                var license = this.state.Licenses[i];
                if(license.id == this.props.state.FilterDesignsByLicense)
                    return license as Tgcc.License;
            }
        }
        return undefined;
    }

    getDesignLicenseHeader(){
        if(this.state.licenseId){
        var selectedLicense = this.getSelectedLicense();
        if(selectedLicense)
            return <DesignLicenseHeader key={this.props.state.FilterDesignsByLicense} license={selectedLicense} onChange={this.handleFilterByLicense} ></DesignLicenseHeader>
        }
        return undefined;
    }

    getDesignLicenses() {
        if(!this.state.licenseId){
            var licenses = new Array();
            for (var i in this.state.Licenses) {
                var license: Tgcc.License = this.state.Licenses[i];
                licenses.push(
                    <DesignLicense key={license.id} license={license} onChange={this.handleFilterByLicense}></DesignLicense>
                );
            };
            return licenses;
        }
    }
   
    handleFilterByLicense = (licenseId: number) =>{
        TgccRequest.getDesignLicenseDesignsFiltered(licenseId, null, (Designs : Tgcc.Design[]) => this.DesignsLoaded(Designs))
        this.openDesign();
        this.setState({licenseId: licenseId});
        if(this.state.isWaiting === false){
            this.setState({isWaiting:true})
        }else {
            this.setState({isWaiting:false});
        }
        this.props.dispatch({ type: Tgcc.StateAction.FilterDesignsByLicense, payload: licenseId});
    };

    DesignsLoaded(Designs : Tgcc.Design[]) {
        for(var i in Designs)
            Designs[i].displayIndex = Number(i);
        this.setState({Designs: Designs,isWaiting:false});
    }

    getDesignItems() {
       
        var Designs = new Array();
        var noItemsStyle = { fontFamily: 'CenturyGothic', fontSize:'24px', textAlign: 'center', width: '100%', textTransform: 'uppercase', alignSelf: 'center'};

        if(this.state.Designs && this.props.state.FilterDesignsByLicense){
            if(this.state.Designs.length == 0){
                Designs.push( <div key="none" style={noItemsStyle}>No matching items</div>);
            } 

            for(var i in this.state.Designs){
                var design: Tgcc.Design = this.state.Designs[i];
                Designs.push(<CampusDesignCard key={design.id} design={design} onSelect={this.handleDesignSelection} onZoom={this.handleZoom}/>);
            }
        }
        return Designs;
        
    }

    getBackButton(){
        var style : CSSProperties = {
            fontSize: '14px',
            letterSpacing: '3px',
            textAlign: 'center',
            textTransform: 'uppercase',
            marginTop: '10px',
            backgroundColor: Tgcc.Styles.buttonBackground,
            border: '1px solid tranparent',
            width: '40%',
            cursor: 'pointer',
        };
        return ( <div className="hoverBorder" style={style} onClick={this.handleBackToProof}>back</div>)
    }

    handleBackToProof = () => {
        this.props.dispatch({type: Tgcc.StateAction.SetEditState, payload: Tgcc.EditStates.None})
    }

    handleZoom = (design: Tgcc.Design) => {
        this.setState({zoomDesign:design});
    }

    handleDesignSelection = (design : Tgcc.Design) => {
        this.props.dispatch({type: Tgcc.StateAction.UpdateCampusProofDesign, payload: design});
    }

    selectedImageStyle: CSSProperties = {
         display: 'flex',
         width: '200px',
         alignSelf: 'center',
         cursor: 'zoom-in'
    }

    handleDetailBackButton = () => {
        this.setState( { design: null});
    }

    onSubmit(e){
        e.preventDefault();
    }

    mobileCheck() {
        var isMobile = {
            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini|Opera Mobi/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
            }
        };
    }

    render() {
        var licenses = this.state.Licenses ? this.getDesignLicenses() : <Tgcc.LoadingElement />;
        var licenseHeader = this.state.licenseId && this.state.Licenses ? this.getDesignLicenseHeader() : undefined;
        var designs = undefined;
        if(licenseHeader)
            designs = this.state.isWaiting ? <Tgcc.LoadingElement /> : this.getDesignItems();
        licenseContainerStyle.display = licenseHeader ? 'none' : 'flex';
        catalogStyle.display = licenseHeader ? 'flex' : 'none';
        return (
                    <div style={selectorStyle}>
                    <div id='schoolPage'></div>
                        <CampusHeader />
                        <CampusFeedback state={this.props.state} />
                        <div style={otherSchoolLink} onClick={this.openOtherSchools} className='otherSchoolLink'>Don&#39;t see your school&#63;</div>
                        <div style={licenseContainerStyle} className="licenseContainerStyle">
                            <div style={licenseListStyle} className='licenseListStyle'>{licenses}</div>
                        </div>
                        {licenseHeader}
                        <div style={catalogStyle} className='campusSchoolCont'>
                            {designs}
                        </div>
                        {this.getZoomedDesign()}
                        <CampusFooter state={this.props.state} router={this.props.router}/>
                    </div>
                )
    }

    getZoomedDesign = () =>  {
        if(!this.state.zoomDesign)
            return (<a/>);

       let fullSizeStyle: CSSProperties = {
            position: 'relative',
            background: 'white',
            border: Tgcc.Styles.singleBorder,
            boxShadow: Tgcc.Styles.boxShadow,
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            alignSelf: 'center',
            width: '600px',
            height: '800px',
            maxWidth: '90%',
            maxHeight: '75%',
            top:'10%',
            '@media (max-width:768px) and (max-height:1024px)': {
                margin:'30px auto'
            }
           
       };

        let imgStyle: CSSProperties = {
            width: 'auto',
            height: 'auto',
            maxWidth: '80%',
            maxHeight: '75%',
            display: 'block',
            alignSelf: 'center',
            cursor: 'zoom-out'
        };

        let screenDoor: CSSProperties = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 99,
            backgroundColor: 'rgba(22,22,22,0.5)',
            justifyContent: 'center',
            alignContent: 'center',
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            overflowX: 'hidden'
        }        
        let footerStyle: CSSProperties ={
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: '10px'
        }
        let arrowStyle: CSSProperties = {
            cursor: 'pointer',
            fontSize: '70px',
            height: '40px',
            lineHeight: '30px',
            color: 'darkgray',
            display: 'flex',
            alignSelf: 'center'
        }
        var largeImg = Tgcc.getDesignPath(this.state.zoomDesign.image);
        return ( 
            <ScreenDoor>
                <div style={fullSizeStyle} className="fullSizeStyle">
                    <CloseX closeAction={this.hideZoom} />
                    <img src={largeImg} style={imgStyle} alt={largeImg} onError={Tgcc.handleDesignImageError} onClick={this.hideZoom}/> 
                    <div style={footerStyle}>
                        <div style={arrowStyle} onClick={this.handlePrev}>&lsaquo;</div>
                        <div className="grayButton" style={addToProofBtn} onClick={this.handleZoomAdd}>add to proof</div>
                        <div style={arrowStyle} onClick={this.handleNext}>&rsaquo;</div>
                    </div>  
                </div>
            </ScreenDoor>
        )
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    hideZoom = () => {
        this.setState({zoomDesign: null});
    }

    handleZoomAdd = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        this.handleDesignSelection(this.state.zoomDesign);
    }

    handlePrev = (evt: React.MouseEvent<HTMLDivElement>) =>{
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex-1;
        curIndex = curIndex < 0 ? this.state.Designs.length - 1 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }

    handleNext = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        var curIndex = this.state.zoomDesign.displayIndex+1;
        curIndex = curIndex >= this.state.Designs.length ? 0 : curIndex;
        this.setState({zoomDesign: this.state.Designs[curIndex]});
    }
}
  
const mapStateToProps = (state : Tgcc.GlobalState ) => {
    return {state:state}
};

export var Schools = connect(mapStateToProps)(Radium(_Schools));